// extracted by mini-css-extract-plugin
export default {"vv-overview-dropdown":"VerifiedVoicesOverviewDropdown_vv-overview-dropdown__pYP9Q","vv-overview-link":"VerifiedVoicesOverviewDropdown_vv-overview-link__MGX9X"};